import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useLinkLikeClick } from '../../../../hooks'
import { ListItem } from '../../../ListItem'
import {
  getListingProfileLink,
  getListingUnitLabel,
} from '../../../RentalPortalListing'
import { Widget } from '../../../Widget'
import { QA_NAME_VIEWING_PROFILE_WIDGET_LISTING } from '../RentalPortalViewingProfile.constants'
import { useViewingProfileContext } from '../RentalPortalViewingProfile.hooks'

import * as styles from './RentalPortalViewingProfileWidgetListing.module.css'

import RentalPortalIcon from '../../../../icons/rental-portal.svg'

function RentalPortalViewingProfileWidgetListing() {
  const { t } = useTranslation()

  const { handleClick } = useLinkLikeClick()

  const { isInitiated, viewingData } = useViewingProfileContext()

  function handleClickListing(listingId) {
    handleClick({ link: getListingProfileLink(listingId) })
  }

  return (
    <Widget
      contentContainerProps={{ className: styles.content }}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated || !viewingData}
      qaName={QA_NAME_VIEWING_PROFILE_WIDGET_LISTING}
      title={t('RentalPortal.ViewingListingColumnKey')}
    >
      <ListItem
        ListIcon={RentalPortalIcon}
        className={styles.item}
        hoverClassName={styles.hover}
        text={getListingUnitLabel({ listing: viewingData, t })}
        tooltipAdditionalText={t('Common.ClickToOpenProfileKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        value={viewingData?.listing_id}
        onClick={handleClickListing}
      />
    </Widget>
  )
}

export default RentalPortalViewingProfileWidgetListing
